import React from 'react'

import { Deviation, Outcome, Prediction } from '@app/graphql/types'
import { bemJoin } from '@app/lib/bem'
import { CheckResultsTable } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsTable'
import { HighlightedResult } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/HighlightedResult'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'
import { formatNumber } from '@app/modules/Messages/Components/UtilityBillAICheckResults/utils'

import './BenchmarkDeviationsCheckResultsTable.scss'

export type Props = {
  check: UtilityBillAnalysisChecks['benchmarkDeviations']
}

const deviationMap = {
  [Deviation.Minor]: 'leicht erhöht',
  [Deviation.Major]: 'stark erhöht',
  [Deviation.Negligible]: 'geringfügig',
  [Deviation.Inconclusive]: 'unklar'
}

export const BenchmarkDeviationsCheckResultsTable = ({ check }: Props) => {
  const b = bemJoin('benchmark-deviations-check-results')

  const rows = check.children.filter((item) => {
    if (item.outcome === Outcome.Pass) {
      return false
    }

    const isPredictedAsNotOk = [Prediction.NotOk, Prediction.Questionable].includes(
      item.context.prediction as any
    )
    const hasMinorOrMajorDeviation = [Deviation.Minor, Deviation.Major].includes(
      item.context.deviation as any
    )

    // Items that are NotOk and have minor/major deviation will be reflected in the invoice items table
    return !(isPredictedAsNotOk && hasMinorOrMajorDeviation)
  })

  return (
    <CheckResultsTable>
      <table className={b('table')}>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>
              Erhöhung
              <br />
              in %
            </th>
            <th>
              qm Preis
              <br />
              pro Jahr
              <br />
              Mandant:in
            </th>
            <th>
              qm Preis
              <br />
              pro Jahr
              <br />
              Vergleichswert
            </th>
            <th>Wert</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            return (
              <tr key={row.context.item}>
                <td>{row.context.item}</td>
                <td>
                  {row.context.deviation ? (
                    <HighlightedResult isOk={false}>
                      {deviationMap[row.context.deviation]}
                    </HighlightedResult>
                  ) : (
                    'Kein Wert gefunden'
                  )}
                </td>
                <td>{formatNumber(row.context.increaseInPercent, 0)} %</td>
                <td>{formatNumber(row.context.pricePerSqm)} €</td>
                <td>{formatNumber(row.context.pricePerSqmBenchmark)} €</td>
                <td>{formatNumber(row.context.amount)} €</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </CheckResultsTable>
  )
}
